<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span>Setting SMTP</a>
    <FormSettingSMTP v-model="data" @submit="onSubmit" ref="formSettingSMTP" />
  </main>
</template>
<script>
import FormSettingSMTP from "@/components/form/setting-smtp"
import axios from '@/axios';
import { showErrorMessage } from '@/utils';

export default {
  components: {
    FormSettingSMTP
  },
  data() {
    return {
      data: {
        mailer: null,
        host: null,
        port: null,
        username: null,
        password: null,
        encryption: null,
        from_email: null,
        from_name: null,
      },
    }
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
  },
  async created() {
    this.$store.dispatch('toggleLoadingProgress', true)
    try {
      const { data: resData, status } = await axios.get(`/email-settings`)
      if (status !== 200) return
      const { data } = resData

      this.data = {
        mailer: data?.mailer ?? null,
        host: data?.host ?? null,
        port: data?.port ?? null,
        username: data?.username ?? null,
        password: data?.password ?? null,
        encryption: data?.encryption ?? null,
        from_email: data?.from_email ?? null,
        from_name: data?.from_name ?? null,
      }
    } catch (error) {
      showErrorMessage(error)
    } finally {
      this.$store.dispatch('toggleLoadingProgress', false)
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formSettingSMTP.$validator.validateAll();
      if (isValid) {
        try {
          this.$store.dispatch('toggleLoadingProgress', true)
          await axios.post(`/email-settings`, this.data)
          this.$notify({ type: 'success', text: 'Success updating SMTP Setting' })
        } catch (error) {
          showErrorMessage(error)
        } finally {
          this.$store.dispatch('toggleLoadingProgress', false)
        }
      }
    }
  },
  watch: {
    AppActiveUser: {
      handler() {
        if (this.AppActiveUser && this.AppActiveUser?.role !== 'Super Admin') {
          this.$router.push({ name: 'Dashboard' })
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style></style>
